import React from 'react';

import styled from 'styled-components';

import ModelDetailsHeaderAgencies from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsHeader/ModelDetailsHeaderAgencies';

import AddFastPackageButton from '@components/ActivePackages/AddFastPackageButton';
import ContactAlertPopover from '@components/ContactAlert/ContactAlertPopover';
import NwIcon from '@components/Gui/NwIcon';

import ShowSeasonModelWallInfo from '@containers/Booking/ShowSeasons/ShowSeasonModelWallInfo';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

export const MobileCell = styled.div`
    min-height: 6rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.15rem;

    p {
        margin-bottom: 0;
    }

    .name {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        h1 {
            font-size: 1.1rem;
            line-height: 1.1em;
            margin: 0;
            color: ${(props) => (props.$inPackage ? props.theme.PrimaryColor : 'inherit')};
            text-transform: capitalize;
            margin-right: 8px;
        }

        &.in-event {
            h1 {
                color: ${(props) => props.theme.PrimaryColor};
            }
        }
        &.busy {
            h1 {
                color: ${(props) => props.theme.DangerColor};
            }
        }
        &.no-busy {
            h1 {
                color: ${(props) => props.theme.SuccessColor};
            }
        }
    }

    .detail {
        font-size: ${(props) => props.theme.FontSizeSm};
        margin-top: 4px;
        flex: 1;
    }

    .model-icons {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1.5rem;
        font-size: 1.2rem;
    }
`;

const ModelsTableColumnNameMobile = ({
    record,
    multipleSelectionActive,
    availabilityByModel,
    availabilityInfo,
    playlistCount,
    onOpenDrawer,
}) => {
    // const isBusy = modelsAvailability[record.key] && modelsAvailability[record.key].isBusy;
    const isFetched = availabilityByModel[record.key] && availabilityByModel[record.key].isFetched;
    const isBusy = availabilityByModel[record.key] && availabilityByModel[record.key].isBusy;
    const isInEvent = availabilityByModel[record.key] && availabilityByModel[record.key].inEvent;
    let className = 'name';
    if (availabilityInfo.isActive && isFetched) {
        if (isInEvent === 2) {
            className += ' in-event';
        } else if (isBusy) {
            className += ' busy';
        } else {
            className += ' no-busy';
        }
    } else {
        if (isInEvent === 2) {
            className += ' in-event';
        }
    }

    const handleOpenProfileDrawer = () => {
        onOpenDrawer(record.key, 'profile');
    };

    const handleOpenCalendarDrawer = () => {
        onOpenDrawer(record.key, 'calendar');
    };

    const handleOpenBooksDrawer = () => {
        onOpenDrawer(record.key, 'books');
    };

    return (
        <MobileCell $inPackage={playlistCount > 0}>
            <div className={className}>
                <h1>{record.name.toLowerCase()}</h1>
                {record.AL && <ContactAlertPopover contact={record} />}
            </div>
            <div className="detail">
                <ModelDetailsHeaderAgencies readOnly={multipleSelectionActive} model={record} />
                <ShowSeasonModelWallInfo modelId={record.ID} variant="table" />
            </div>
            <div className="model-icons">
                <NwIcon
                    icon={byPrefixAndName.fasl['sidebar-flip']}
                    pointer
                    onClick={handleOpenProfileDrawer}
                    size="lg"
                />
                <NwIcon icon={byPrefixAndName.fasl['calendar']} pointer onClick={handleOpenCalendarDrawer} size="lg" />
                <NwIcon icon={byPrefixAndName.fasl['images']} pointer onClick={handleOpenBooksDrawer} size="lg" />
                <AddFastPackageButton modelID={record.key} noTooltip />
            </div>
        </MobileCell>
    );
};

export default ModelsTableColumnNameMobile;
